/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Partnername1Inputs */

const de__field_partnername1 = /** @type {(inputs: _Field_Partnername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partnername`)
};

/**

* @param {_Field_Partnername1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_partnername1 = /** @type {((inputs?: _Field_Partnername1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Partnername1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_partnername1(inputs)
});
export { _field_partnername1 as "_field_partnerName" }